import { UserDataFormValues } from './types';
import { IUser } from '@/app/state/app/collections/dataTypes';

export const mapUserToUserDataFormValues = (
    user: IUser
): UserDataFormValues => ({
    firstName: user.name ?? '',
    lastName: user.surname ?? '',
    email: user.email ?? '',
});
